import Axios from "axios";
import { round } from "lodash-es";
import { useQuery } from "react-query";

import { Segment } from "src/types";
import { segment as decimalScale } from "src/config/decimal-scales";
import { segmentKeys } from "src/query-keys";

export function useSegments(scenarioId: string | number) {
  async function queryFn(scenarioId: string | number) {
    const url = `/planning-api/scenarios/${scenarioId}/segments`;
    const response = await Axios.get<Segment[]>(url);

    return response.data.map(deserialize);
  }
  return useQuery(segmentKeys.all(scenarioId), () => queryFn(scenarioId));
}

function deserialize(data: Segment): Segment {
  return {
    ...data,
    height_m: round(data.height_m, decimalScale.height_m),
    speed_km_h: round(data.speed_km_h, decimalScale.speed_km_h),
    vehicleCounts: data.vehicleCounts.map((vehicleCount) => {
      return {
        ...vehicleCount,
        count: round(vehicleCount.count, decimalScale.vehicleCounts),
      };
    }),
  };
}
